"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InnerBanner = void 0;
const react_1 = __importDefault(require("react"));
const class_variance_authority_1 = require("class-variance-authority");
const Row_1 = require("../Row");
const image_1 = __importDefault(require("next/image"));
const Container_1 = require("../Container");
const clsx_1 = require("clsx"); // Import clsx to combine class names
// Define variants using CVA
const bannerVariants = (0, class_variance_authority_1.cva)('relative gap-[18px] flex flex-col justify-center before:absolute before:content-[""] before:top-1/2 before:h-full before:w-full before:z-[-1] before:transform before:-translate-y-1/2', {
    variants: {
        color: {
            orange: "bg-[#EF9300E5]",
            purple: "bg-[#BB008EE5]",
            green: "bg-[#003D2A]",
            none: "",
        },
        withBefore: {
            orange: `
          before:bg-[#EF9300E5]
          before:left-[-100%]
        `,
            purple: `
          before:bg-[#BB008EE5]
          before:left-[-100%]
        `,
            green: `
        before:bg-[#003D2A]
        before:left-[-100%]
      `,
            none: "",
        },
        withAfter: {
            orange: `
          before:bg-[#EF9300E5]
          before:right-[-100%]
        `,
            purple: `
          before:bg-[#BB008EE5]
          before:right-[-100%]
        `,
            green: `
        before:bg-[#003D2A]
        before:right-[-100%]
      `,
            none: "",
        },
        padding: {
            LeftSideNone: "pt-[50px] pb-[72px] pr-[79px] pl-0",
            AllSide: "pt-[50px] pb-[72px] pl-[79px] pr-[79px]",
        },
        width: {
            small: "w-[100%] lg:w-[40%]", // 40% width
            medium: "w-[100%] lg:w-[50%]", // 50% width (default)
            large: "w-[100%]", // 100% width
        },
        height: {
            full: "h-full", // Full height
            none: "",
        },
        borderRadius: {
            none: "rounded-none",
            right: "rounded-[300px_0_0_300px]",
            left: "rounded-[0_300px_300px_0]",
        },
    },
    defaultVariants: {
        color: "orange",
        withBefore: "orange",
        withAfter: "green",
        padding: "LeftSideNone",
        width: "medium", // Default width
        height: "none", // Default height
        borderRadius: "none", // Default border radius
    },
});
const InnerBanner = ({ color, withBefore, withAfter, padding, width = "medium", // Default to 'medium'
height = "none", // Default to 'none'
leftColumnContent, rightColumnContent, backgroundImage, // Accept dynamic background image
borderRadius = "none", // Default to 'none'
className, // Destructure className
 }) => {
    return (react_1.default.createElement("div", { className: "relative w-full overflow-hidden" },
        react_1.default.createElement(Container_1.Container, { className: "relative z-[1] min-h-[350px]" },
            react_1.default.createElement(Row_1.Row, { className: `h-full flex items-center gap-[16px] ${rightColumnContent ? "justify-end" : ""}` },
                leftColumnContent && (react_1.default.createElement("div", { className: (0, clsx_1.clsx)(bannerVariants({
                        color,
                        withBefore,
                        withAfter,
                        padding,
                        width,
                        height,
                        borderRadius,
                    }), className // Add custom class here
                    ) }, leftColumnContent)),
                rightColumnContent && width !== "large" && (react_1.default.createElement("div", { className: (0, clsx_1.clsx)(bannerVariants({
                        color,
                        withBefore,
                        withAfter,
                        padding,
                        width,
                        height,
                        borderRadius,
                    }), className // Add custom class here
                    ) }, rightColumnContent)))),
        react_1.default.createElement("div", { className: "absolute inset-0" },
            react_1.default.createElement(image_1.default, { src: backgroundImage, className: "object-cover", layout: "fill", loading: "eager", alt: "Background Image", priority: true }))));
};
exports.InnerBanner = InnerBanner;
